import React from 'react';
import { Tooltip, Icon, Text } from '@amzn/storm-ui-v3';
import { exclamation } from '@amzn/storm-ui-icons-v3';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const StyledIcon = styled(Icon)`
  color: ${props => props.theme.palette.red[600]};
`;

const StyledButton = styled.button`
  border: none;
  background-color: transparent;
  padding: ${({ theme }) => theme.spacing.none};
`;

export function ErrorTooltip(props: { errorMessage?: string }) {
  const { t: translate } = useTranslation();
  const message =
    props.errorMessage || translate('sspa_rcm_ad_schedule_toggle_failure_tooltip_message', 'Something happened. Please try again');
  return (
    <Tooltip
      trigger={
        <StyledButton aria-haspopup='dialog'>
          <StyledIcon type={exclamation} size='sm' />
          <Text type='sr-only'>{message}</Text>
        </StyledButton>
      }
      message={message}
      position='top'
      type='dark'
    />
  );
}
